// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_2pN","cls2":"ReportList-cls2_Dal ReportList-cls1_2pN"};